var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "searchcontainer" },
    [
      _c(
        "div",
        { staticClass: "w-full md:w-6/12 md:pr-sm relative mb-md z-10" },
        [
          _c(
            "label",
            {
              staticClass: "font-semibold mb-xxs inline-block",
              attrs: { for: "search" },
            },
            [_vm._v("Zoeken")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchInput,
                  expression: "searchInput",
                },
              ],
              staticClass: "form__input form__input--filled-dark",
              attrs: {
                id: "search",
                autofocus: "",
                type: "text",
                placeholder: _vm.placeholder,
              },
              domProps: { value: _vm.searchInput },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchInput = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("productoverview", {
        ref: "overview",
        attrs: { search: _vm.searchInput },
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none",
      },
      [_c("i", { staticClass: "fa-regular fa-search" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }